<!-- Content Row -->
<!-- For super admin only-->
@if (authService.isSuperadmin && isAdmin) {
  <div>
    <button (click)='goBack()' class="btn btn-sm btn-primary">Back</button>
  </div>
}
<br/>
@if (!shouldHideAdminCounts()) {
  <div class="row counts-comp">
    <!-- Total Partners Card -->
    @if (authService.hasAccess(Role.SuperAdmin)) {
      <div class="col-xl-3 col-md-6 mb-4">
        <a [routerLink]="['/dashboard/partner/list']">
          <div class="card border-left-warning h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-md font-weight-bold text-warning text-uppercase mb-1">Total Partners</div>
                  <div class="h6 mb-0 font-weight-bold text-gray-800">{{partnersCount}}</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-handshake fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    }
    <!-- Total customer Card -->
    @if (authService.hasAccess(Role.PartnerAdmin)) {
      <div (click)="showCustomers()" class="col-xl-3 col-md-6 mb-4">
        <a [routerLink]="['/dashboard/customer/list']">
          <div class="card border-left-primary h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-md font-weight-bold text-primary text-uppercase mb-1">Total Customers</div>
                  <div class="h6 mb-0 font-weight-bold text-gray-800">{{customersCount}}</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-users fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    }
    <!-- Total Project -->
    @if (authService.hasAccess(Role.CustomerAdmin)) {
      <div class="col-xl-3 col-md-6 mb-4">
        <a [routerLink]="['/dashboard/project/list']">
          <div class="card border-left-success  h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-md font-weight-bold text-success text-uppercase mb-1">Total Projects</div>
                  <div class="h6 mb-0 font-weight-bold text-gray-800">{{projectsCount}}</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-book fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    }
    <!-- Total Users -->
    @if (authService.hasAccess(Role.CustomerAdmin)) {
      <div (click)='showUsers()' class="col-xl-3 col-md-6 mb-4">
        <a [routerLink]="['/dashboard/user/list']">
          <div class="card border-left-info  h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-md font-weight-bold text-info text-uppercase mb-1">Total Users</div>
                  <div class="h6 mb-0 font-weight-bold text-gray-800">{{usersCount}}</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-user fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    }
  </div>
}


<!-- User counts (or admin if viewing project) -->
@if (authService.isReadOnly || (authService.hasAccess(Role.CustomerAdmin) && shouldHideAdminCounts())) {
  <div class="row">
    <!-- Assigned Project Card -->
    <div class="col-xl-3 col-md-6 mb-4 project-card">
      <div class="card border-left-primary  h-100 py-2">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="text-md font-weight-bold text-primary text-uppercase mb-1">Project</div>
              <div class="h6 mb-0 font-weight-bold text-gray-800">
                @if (authService.isReadOnly) {
                  <select class="form-control form-control-sm" (change) = 'selectProject($event)'>
                    <option selected disabled>Select Project</option>
                    @for (project of projectsList; track project) {
                      <option  [value]="project.name">{{project.name}}</option>
                    }
                  </select>
                }
                @if (authService.hasAccess(Role.CustomerAdmin) && shouldHideAdminCounts()) {
                  <div>{{ activeProject.name }}</div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Media Count -->
    @if (!!activeProject) {
      <div class="col-xl-2 col-md-6 mb-4">
        <div class="card border-left-warning  h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-md font-weight-bold text-warning text-uppercase mb-1">Media Count</div>
                <div class="h6 mb-0 font-weight-bold text-gray-800">{{mediaCount}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <!-- Total File -->
    @if (!!activeProject) {
      <div class="col-xl-2 col-md-6 mb-4">
        <div class="card border-left-success  h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-md font-weight-bold text-success text-uppercase mb-1">Total Files</div>
                <div class="h6 mb-0 font-weight-bold text-gray-800">{{ fileCount | number }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <!-- File Sizes -->
    @if (!!activeProject) {
      <div class="col-xl-2 col-md-6 mb-4">
        <div class="card border-left-info  h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-md font-weight-bold text-info text-uppercase mb-1">Total File Size</div>
                <div class="h6 mb-0 font-weight-bold text-gray-800">{{fileSize}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}